import React from "react";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Status from "components/presentation/Status";
import { Stack } from "react-bootstrap";
import SportCode from "components/common/SportCode";
import { getDateTimeFormat } from "helpers/utils";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

export function CompetitorBlock(competitor) {
    const { mirs_event } = useUrlFriendlyToParameters()
    let seed = ''
    let competitorBracket;
    if (competitor.co_seed) {
        seed = '(' + competitor.co_seed + ')'
    }

    let athletes = [];
    competitor?.participant?.athletes?.map(o =>
        athletes?.push(
            { order: o?.order, athlete: o?.person }
        )
    )

    competitorBracket = <Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} />

    if (mirs_event?.includes("DOUBLES")) {
        competitorBracket = <Competitor teamAthletes={athletes} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} />
    }

    //Check if the game is singles or doubles

    return (
        <div className='score-competitor-container d-flex justify-content-start '>
            <div className='score-noc'>
                <Noc {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name d-flex align-items-center text-truncate'>
                <Stack direction="horizontal" className="w-100">
                    <Stack direction="vertical" className="text-truncate">{competitorBracket}</Stack>
                    <sup>{seed}</sup>
                </Stack>
            </div>
        </div>

    )
}

export function Footer({ data }) {
    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date

    let location = data?.schedule?.location?.shortDescription

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            {isLessLiveStatus(data?.result?.status?.code)
                && <div className='row w-100'><div className='text-start col'>{dateComponent}</div><div className='text-end col'>{location}</div></div>}
        </>
    )
}